import getCardService from '../services/components/get_card.jsx'


const getState = (cardState, display) => ({ type: "CARD_STATE", cardState, display })


export const getCardAction = (dstate) => dispatch => {
    let state = []
    getCardService((data, msg) => {
        if (msg === "success") {
            state = {
                message: "Success",
                status: 200,
                body: data
            }
            localStorage.setItem("cardState", JSON.stringify(state))
            
        }
        else if (msg === "emptyBody") {
            
            state = {
                message: "Empty Body",
                status: 204,
                body: data
            }
        }
        else {
            state = data
        }
        dispatch(getState(state, true))
    }, dstate)
}

export const clearInputAction = () => dispatch => {
    let state = {
        status: 204,
        body: []
    }
    dispatch(getState(state))
}



// WEBPACK FOOTER //
// ./src/actions/getcardaction.jsx